// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { constants } from "@hardwoods/XDL/constants";

export const virtualScroll = function (event: any) {
    const element = event.currentTarget;
    let d = 0;
    if (event.wheelDelta) {
        d = event.wheelDelta || -event.detail;
    } else if (event.deltaY !== 0) {
        // for Firefox
        d = -event.deltaY;
    }
    // eslint-disable-next-line react/no-this-in-sfc
    element.scrollTop += (d < 0 ? 1 : -1) * 30;
};

export const stopParentScroll = (e: any) => {
    const prevent = function () {
        e.stopPropagation();
        e.preventDefault();
        e.returnValue = false;
        return false;
    };
    return prevent();
};

export const scrollToTop = () => {
    setTimeout(() => {
        typeof window !== "undefined" && window.scrollTo(0, 0);
    }, 500);
};

export const handleScrollToSection = (currentStep: number, headerHeight: number, isMobile: boolean) => {
    const element =
        typeof document !== "undefined" && document.querySelector(`[data-activation-step="${currentStep}"]`);
    if (!element) {
        return;
    }

    const box = element?.getBoundingClientRect();
    const scrollTop = window.pageYOffset;

    if (element) {
        let offsetHeaderTop = constants.header.size.sticky + 10;
        if (isMobile) {
            offsetHeaderTop = headerHeight;
        }
        const offset = (box?.top ?? 0) + scrollTop;
        window.scrollTo(0, offset - offsetHeaderTop);
    }
};
